module.exports = __webpack_public_path__ + "img/edit-icon.899dda7d.svg";